import { SEO } from "@/components/common/SEO";
import { PageHero } from "@/components/sections/PageHero";
import { Container } from "@/components/ui/Container";
import { Section } from "@/components/ui/Section";
import { SITE_CONTACT } from "@/data/site";

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="How MedCore Research handles information submitted through this website."
        path="/privacy"
      />
      <PageHero
        eyebrow="Website Privacy"
        title="Privacy Policy"
        description="How information submitted through the MedCore Research website is handled."
      />
      <Section>
        <Container className="max-w-3xl space-y-9">
          <section>
            <h2 className="text-2xl font-semibold">Information we collect</h2>
            <p className="mt-3 leading-relaxed text-muted-foreground">
              The inquiry form may collect your name, organization, role, email
              address, phone number, therapeutic area, study phase, preferred
              contact method, inquiry type, and message.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold">How we use information</h2>
            <p className="mt-3 leading-relaxed text-muted-foreground">
              Information submitted through the website is intended to be used
              to review and respond to business, practice, study, and partnership
              inquiries.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold">Do not submit patient information</h2>
            <p className="mt-3 leading-relaxed text-muted-foreground">
              Do not submit patient-identifiable information, medical records,
              study identifiers, signatures, or confidential clinical documents
              through the public website form.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold">Form delivery</h2>
            <p className="mt-3 leading-relaxed text-muted-foreground">
              We use Cloudflare to process website form submissions and Resend
              to send inquiries to our support inbox. The information you submit
              is processed by these providers to deliver your inquiry and is
              received by MedCore Research through its email service.
            </p>
            <p className="mt-3 leading-relaxed text-muted-foreground">
              Cloudflare Turnstile checks submissions for automated abuse. To
              limit repeated attempts, we also keep a protected identifier
              derived from your IP address, an attempt count, and an expiration
              time. The rate-limit database does not store form messages or raw
              IP addresses. Expired counters are removed on a subsequent submission.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold">Contact</h2>
            <p className="mt-3 leading-relaxed text-muted-foreground">
              For questions about website privacy, contact{" "}
              <a
                href={`mailto:${SITE_CONTACT.email}`}
                className="font-medium text-primary underline underline-offset-2"
              >
                {SITE_CONTACT.email}
              </a>
              .
            </p>
          </section>
          <p className="rounded-xl border border-border bg-muted p-4 text-sm leading-relaxed text-muted-foreground">
            This website privacy page should be reviewed by MedCore Research
            before launch and updated to reflect the final form provider,
            retention practices, and applicable legal requirements.
          </p>
        </Container>
      </Section>
    </>
  );
}
